import { Separator } from 'components/Separator'
import { ComponentType } from 'react'
import StickyBox from 'react-sticky-box'
import { Col, Container, Row } from 'reactstrap'
import styled from 'styled-components'
import { Agent } from './agent'
import { Badges } from './badges'
import { Details } from './details'
import { Extract } from './extract'
import { Description } from './description'
import { Extras } from './extras'
import { Gallery } from './gallery'
import { Map } from './map'
import { Places } from './places'
import { Tabs } from './tabs'

const Wrapper = styled.div`
  padding-bottom: 10px;
`

interface Props {
  property: any
  agent: any
  beforeOnShareClick: () => Promise<void>
  shareUrl: string
}

export const PropertyDesktop: ComponentType<Props> = ({ property, agent, beforeOnShareClick, shareUrl }) => {
  return (
    <Wrapper className="print--none">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8}>
            <Gallery property={property} />
            <Badges property={property} />
            <Row>
              <Col sm={6} md={7}>
                <Extract property={property} />
                <Separator />
                <Places property={property} />
                <Separator />
                <Details property={property} />
              </Col>
              <Col sm={6} md={5}>
                <StickyBox offsetTop={100} offsetBottom={20}>
                  <Agent property={property} agent={agent} beforeOnShareClick={beforeOnShareClick} shareUrl={shareUrl} />
                </StickyBox>
              </Col>
            </Row>
            <Separator />
            <Map property={property} />
            <Extras property={property} />
            <Tabs property={property} />
            <Separator />
            <Description property={property} />
          </Col>
        </Row>
      </Container>
    </Wrapper>
  )
}
